import { Theme } from '@mui/material';


const Accordion = (theme: Theme) => {
  return {
  };
};

export default Accordion;
